// AUTO GENERATED FILE - DO NOT EDIT
export default {
  soho_addons_active_addons_empty_text: 'You don’t have any active Add-ons. Tap on Buy Add-ons to shop.',
  soho_addons_add_users_button: 'Users',
  soho_addons_addon_description_show_less: 'Show less',
  soho_addons_addon_description_show_more: 'Show more',
  soho_addons_addon_number_of_users_label: '%1$s users',
  soho_addons_buy_addon_auto_renew_label: 'Auto renew',
  soho_addons_buy_addon_button_buy_this_addon_label: 'Buy this Add-on',
  soho_addons_buy_addon_starting_today_label: 'Starting today',
  soho_addons_buy_addons_button_title: 'Buy Add-ons',
  soho_addons_buy_addons_expiration_date_label: 'Expiration date',
  soho_addons_buy_addons_inc_vat_label: 'inc VAT',
  soho_addons_buy_quick_action_cancel_button_title: 'Cancel',
  soho_addons_buy_quick_action_confirm_button_title: 'Confirm',
  soho_addons_buy_quick_action_confirmation_description: 'Are you sure you want to buy %1$s add-on?',
  soho_addons_buy_quick_action_description: 'Would you like to buy this add on and apply it to all the selected users?',
  soho_addons_buy_quick_action_hint: 'You will still be able to start using this add-on from today.',
  soho_addons_buy_quick_action_title: 'Buy Add-on',
  soho_addons_buy_success_modal_description: '%1$s has been successfully added to your add-ons.',
  soho_addons_cancel_request_quick_action_title: 'Cancel request Add-on',
  soho_addons_cancel_request_success_modal_description: '%1$s has been successfully removed from your requested addons.',
  soho_addons_cancel_request_success_modal_title: 'Request cancelled',
  soho_addons_card_price: '%1$s /%2$s',
  soho_addons_congratulations_overlay_title: 'Congratulations!',
  soho_addons_cost_per_month: 'per month',
  soho_addons_edit_success_modal_description: 'The list of users on this add-on has been successfully updated.',
  soho_addons_edit_user_quick_action_cancel_button_title: 'Cancel',
  soho_addons_edit_user_quick_action_confirm_button_title: 'Confirm',
  soho_addons_edit_user_quick_action_confirmation_description: 'Are you sure you want to apply this change to %1$s add-on?',
  soho_addons_edit_user_quick_action_description: 'The cost change after editing users on an existing add-on will be reflected on the next bill cycle.',
  soho_addons_edit_user_quick_action_hint: 'The cost change after editing users on an existing add-on will be reflected on the next bill cycle.',
  soho_addons_edit_user_quick_action_hint_second_paragraph: 'All users will be able to continue to use this add-on regularly.',
  soho_addons_edit_user_quick_action_title: 'Apply changes',
  soho_addons_empty_text: 'You don’t have any Add-ons. Tap on Buy Add-ons to shop.',
  soho_addons_failure_error_message: 'An error has occurred and we\'re having some trouble loading your content.',
  soho_addons_failure_modal_cancel: 'Cancel',
  soho_addons_failure_modal_close: 'Close',
  soho_addons_failure_modal_description: 'Unfortunately we were unable to process your request.',
  soho_addons_failure_modal_title: 'Something went wrong!',
  soho_addons_failure_modal_try_again: 'Try again',
  soho_addons_modal_loading_screen_subtitle: 'Processing…',
  soho_addons_modal_removing_screen_subtitle: 'Removing…',
  soho_addons_my_profile_my_addons_active_empty_text: 'You don’t have any active Add-ons. Tap on Request Add-ons to shop.',
  soho_addons_my_profile_my_addons_empty_text: 'You don’t have any Add-ons. Tap on Request Add-ons to shop.',
  soho_addons_my_profile_request_addons_screen_title: 'Request Add-ons',
  soho_addons_primary_button: 'Request Add-ons',
  soho_addons_recommended_for_you: 'Recommended for you',
  soho_addons_remove_addon_based_on_label: '%1$s users',
  soho_addons_remove_addon_button_apply_changes_label: 'Apply changes',
  soho_addons_remove_addon_renewal_date_label: 'Renewal date',
  soho_addons_remove_addon_secondary_button_remove_this_addon_label: 'Remove',
  soho_addons_remove_addon_total_cost_label: 'Total cost',
  soho_addons_remove_my_addons_expiration_date_label: 'Expiration date',
  soho_addons_remove_quick_action_cancel_button_title: 'Cancel',
  soho_addons_remove_quick_action_confirm_button_title: 'Confirm',
  soho_addons_remove_quick_action_confirmation_description: 'Are you sure you want to remove %1$s add-on?',
  soho_addons_remove_quick_action_description: 'Are you sure you want to remove this Add-on? All users currently on it will be affected.',
  soho_addons_remove_quick_action_hint: 'Users will still be able to use this add-on until %1$s',
  soho_addons_remove_quick_action_title: 'Remove Add-on',
  soho_addons_remove_success_modal_description: '%1$s add-on has been successfully removed.',
  soho_addons_remove_success_modal_title: 'Add-on Removed!',
  soho_addons_request_addon_duration_label: 'Duration',
  soho_addons_request_quick_action_cancel_button_title: 'Cancel',
  soho_addons_request_quick_action_confirm_button_title: 'Confirm',
  soho_addons_request_quick_action_title: 'Request Add-on',
  soho_addons_request_success_modal_description: '%1$s has been successfully added to your requested addons.',
  soho_addons_request_success_modal_title: 'Request submitted',
  soho_addons_shop_addons_error_try_again: 'Try again',
  soho_addons_shop_addons_other_filter: 'Other',
  soho_addons_shop_addons_screen_title: 'Add-ons',
  soho_addons_shop_addons_see_all_filter: 'See all',
  soho_addons_shop_addons_subtitle_add_more_addons: 'Add more Add-ons to your mobile phone',
  soho_addons_shop_addons_title_shop_addons: 'Shop Add-ons',
  soho_addons_success_modal_return_to_addons: 'Return to Add-ons',
  soho_addons_success_modal_title: 'Congratulations!',
  soho_addons_table_active_addons: 'Active Add-ons',
  soho_addons_table_expired_addons: 'Expired Add-ons',
  soho_addons_table_title: 'My Add-ons',
  soho_addons_user_active_addons_empty_text: '%1$s doesn’t have any active Add-ons. Tap on Buy Add-ons to shop.',
  soho_addons_user_addons_empty_text: '%1$s doesn’t have any Add-ons. Tap on Buy Add-ons to shop.',
  soho_addons_user_count_format: '%1$s user',
  soho_addons_users_count_format: '%1$s users',
  soho_addons_users_hint: 'Tap users to view or edit the users',
  soho_application_pdp_purchase_failure_modal_description: 'Unfortunately we were unable to process your request. Please try again later.',
  soho_application_pdp_purchase_failure_modal_primary_button: 'Try again',
  soho_application_pdp_purchase_failure_modal_secondary_button: 'Cancel',
  soho_application_pdp_purchase_failure_modal_title: 'Something went wrong!',
  soho_application_pdp_purchase_modal_loading_screen_subtitle: 'Purchasing…',
  soho_application_pdp_purchase_request_success_modal_title: 'Congratulations!',
  soho_application_pdp_purchase_success_modal_description: 'You have purchased %1$s licence successfully!',
  soho_application_pdp_purchase_success_modal_primary_button: 'Back to marketplace',
  soho_application_pdp_recommended_for_you_plan_qam_close_btn_text: 'Close',
  soho_application_pdp_recommended_for_you_plan_qam_title: 'Recommended for you',
  soho_budget_screen_title: 'Pre-authorised payments',
  soho_business_overview_addons_tab_title: 'Add ons',
  soho_business_overview_billing_button_text: 'Billing',
  soho_business_overview_budget_tab_title: 'Budget',
  soho_business_overview_current_bill: 'Current bill',
  soho_business_overview_cvm_page_banner_description_plural: 'Would you like to review these?',
  soho_business_overview_cvm_page_banner_description_singular: 'Would you like to review this?',
  soho_business_overview_cvm_page_banner_devices_title_plural: '%1$s, you have %2$s new requests for devices',
  soho_business_overview_cvm_page_banner_devices_title_singular: '%1$s, you have %2$s new request for devices',
  soho_business_overview_cvm_page_banner_licences_primary_button_title: 'Yes please',
  soho_business_overview_cvm_page_banner_licences_secondary_button_title: 'No thanks',
  soho_business_overview_cvm_page_banner_licences_title_plural: '%1$s, you have %2$s new licence requests pending',
  soho_business_overview_cvm_page_banner_licences_title_singular: '%1$s, you have %2$s new licence request pending',
  soho_business_overview_cvm_page_banner_plans_title_plural: '%1$s, you currently have %2$s plans due for upgrade',
  soho_business_overview_cvm_page_banner_plans_title_singular: '%1$s, you currently have %2$s plan due for upgrade',
  soho_business_overview_cvm_page_banner_primary_button_title: 'View plan',
  soho_business_overview_cvm_page_banner_secondary_button_title: 'No, thanks',
  soho_business_overview_cvm_page_banner_usage_title_plural: '%1$s, you have %2$s users that are exceeding their plans allocated usage',
  soho_business_overview_cvm_page_banner_usage_title_singular: '%1$s, you have %2$s user that is exceeding their plans allocated usage',
  soho_business_overview_devices_tab_show_less_title: 'Show less',
  soho_business_overview_devices_tab_title: 'Devices',
  soho_business_overview_licences_tab_title: 'Licences',
  soho_business_overview_number_of_users: '%1$s users',
  soho_business_overview_plan_tab_title: 'Plans',
  soho_business_overview_settings_tab_header_title: 'Requesting licences',
  soho_business_overview_settings_tab_title: 'Settings',
  soho_business_overview_title: 'Business overview',
  soho_business_overview_usage_tab_title: 'Usage',
  soho_contracted_product_details_error_message: 'An error has occurred and we’re having some trouble loading your content.',
  soho_contracted_product_details_error_try_again: 'Try again',
  soho_current_licence_title: 'Current licence',
  soho_dashboard_applications_available_applications: 'There are %1$s applications available',
  soho_dashboard_applications_card_tile_title: 'Applications',
  soho_dashboard_applications_company_licences: 'Company licences',
  soho_dashboard_applications_explore_applications: 'Explore applications',
  soho_dashboard_applications_explore_show_more_title: 'Show more',
  soho_dashboard_applications_explore_sub_title: 'There are %1$s available applications',
  soho_dashboard_applications_explore_title: 'Explore applications',
  soho_dashboard_applications_filter_bundles: 'Bundles',
  soho_dashboard_applications_filter_collaboration: 'Collaboration',
  soho_dashboard_applications_filter_favourite: 'Favourited',
  soho_dashboard_applications_filter_field_force: 'Field force management',
  soho_dashboard_applications_filter_iot: 'IOT',
  soho_dashboard_applications_filter_managed_security: 'Managed Security',
  soho_dashboard_applications_filter_security: 'Security',
  soho_dashboard_applications_filter_see_all: 'See all',
  soho_dashboard_applications_filter_tradesperson: 'Tradesperson',
  soho_dashboard_applications_find_out_more: 'Find out more',
  soho_dashboard_applications_licences_badge: '%1$s licences',
  soho_dashboard_applications_recommended_for_you: 'Recommended for you',
  soho_dashboard_applications_see_all: 'See all',
  soho_dashboard_applications_see_more: 'See more',
  soho_dashboard_applications_show_more: 'Show more',
  soho_dashboard_applications_user_licences: 'My licences',
  soho_dashboard_applications_view_licence: 'View licence',
  soho_dashboard_applications_web_builders: 'Web builders',
  soho_dashboard_plan_details_card_tile_title: 'Plan details',
  soho_devices_assigned_to: 'Assigned to',
  soho_devices_is_empty: 'No active devices',
  soho_devices_screen_sub_title: 'Active devices',
  soho_devices_screen_title: 'My current devices',
  soho_devices_upgrade_free_on: 'You can upgrade for free on',
  soho_devices_upgrade_from: 'You can upgrade from',
  soho_devices_upgrade_now: 'Upgrade Now',
  soho_devices_upgrade_today_for: 'Upgrade today for',
  soho_devices_you_do_not_have_active_devices_here: 'Sorry, you don’t have any active devices here.',
  soho_extras_modal_error_screen_primary_button_title: 'Try again',
  soho_extras_modal_error_screen_title: 'An error has occurred',
  soho_full_error_overlay_back_to_dashboard_text: 'Back to dashboard',
  soho_full_error_overlay_back_to_marketplace_text: 'Back to marketplace',
  soho_full_error_overlay_subtitle: 'An error has occurred and we’re having some trouble loading your content.',
  soho_full_error_overlay_title: 'Oops, there’s a problem!',
  soho_groups_confirmation_loading_modal_title: 'Applying changes…',
  soho_groups_confirmation_modal_description: 'Would you like to apply these changes to the selected users?',
  soho_groups_confirmation_modal_primary_title: 'Confirm',
  soho_groups_confirmation_modal_success_description: 'The list of users in this group has been successfully updated.',
  soho_groups_confirmation_modal_success_primary_button_title: 'Return to Groups',
  soho_groups_confirmation_quick_action_cancel_btn: 'Cancel',
  soho_groups_confirmation_quick_action_confirm_btn: 'Save group name',
  soho_groups_confirmation_quick_action_description: 'What would you like to name it?',
  soho_groups_confirmation_quick_action_input: 'Group name',
  soho_groups_confirmation_quick_action_title: 'Name this group',
  soho_groups_failure_modal_primary_button_title: 'Try again',
  soho_groups_failure_modal_secondary_button_title: 'Back',
  soho_groups_failure_modal_title: 'Something went wrong!',
  soho_groups_loading_modal_title: 'Processing…',
  soho_groups_success_modal_description: 'Your group name has been successfully added.',
  soho_groups_success_modal_primary_button_title: 'Close',
  soho_groups_success_modal_title: 'Congratulations!',
  soho_licence_details_title: 'Licence details',
  soho_licences_and_applications_count: 'You have %1$s licences within %2$s applications',
  soho_licences_empty_description: 'No available licenses',
  soho_licences_empty_small_description: 'Sorry, you don’t have any available licences yet.',
  soho_licences_empty_view_message: 'There were no results for “%1$s”. Try a new search',
  soho_licences_failure_error_message: 'An error has occurred and we’re having some trouble loading your content.',
  soho_licences_failure_error_try_again: 'Try again',
  soho_licences_filter_unused_licences: 'Unused licences',
  soho_licences_search_hint: 'Search…',
  soho_licences_statistics_card_title: 'Licences',
  soho_licences_usage: 'Licence usage',
  soho_licences_usage_card_consumption: '%1$s/%2$s',
  soho_licences_used_count_format: '%1$s licences used',
  soho_licences_your_licences: 'Your licences',
  soho_main_tile_my_plan_active_status: 'Active',
  soho_main_tile_my_plan_in_active_status: 'Inactive',
  soho_manage_requests_addon_screen_title: 'Addon request',
  soho_manage_requests_card_title: 'Users requesting product',
  soho_manage_requests_device_screen_title: 'Device request',
  soho_manage_requests_header_description: 'Product ID: %1$s',
  soho_manage_requests_licence_screen_title: 'Licence request',
  soho_manage_requests_screen_title: '%1$s request',
  soho_manage_requests_select_all_button_title: 'Select all',
  soho_manage_requests_title: 'Manage requests',
  soho_marketplace_applications_list_related_products_section_title: 'Related products',
  soho_marketplace_company_licences_badge: '%1$s licences used',
  soho_marketplace_company_licences_header_subtitle: '%1$s licences within %2$s applications',
  soho_marketplace_company_licences_header_title: 'Licences overview',
  soho_marketplace_company_licences_page_title: 'Applications',
  soho_marketplace_company_licences_show_more: 'Show more',
  soho_marketplace_company_licences_subtitle: 'Company licences',
  soho_marketplace_explore_section_no_results_found: 'There were no results for “%1$s”. Try a new search',
  soho_marketplace_full_screen_error_text: 'An error has occurred and we’re having some trouble loading your content.',
  soho_marketplace_lets_refine_your_search: 'Search…',
  soho_marketplace_licence_details_licence_card_include_vat: 'inc. VAT',
  soho_marketplace_licence_details_licence_card_product_id: 'Product ID: %1$s',
  soho_marketplace_licence_details_licence_card_purchase: 'Purchase',
  soho_marketplace_licence_details_licence_card_request: 'Request',
  soho_marketplace_licence_details_licence_card_title: 'Licence',
  soho_marketplace_licence_details_more_information: 'More information',
  soho_marketplace_licence_details_product_information: 'Product info',
  soho_marketplace_licence_details_product_information_find_out_more: 'Find out more',
  soho_marketplace_licence_details_product_information_show_features: 'Show full features',
  soho_marketplace_licence_details_product_information_suggested_plan: 'Suggested plan',
  soho_marketplace_licence_details_product_information_what_is_different: 'What’s different?',
  soho_marketplace_licence_details_related_products_section_title: 'Related products',
  soho_marketplace_licence_details_request_failure_modal_primary_button_title: 'Try again',
  soho_marketplace_licence_details_request_failure_modal_secondary_button_title: 'Back',
  soho_marketplace_licence_details_request_failure_modal_title: 'Something went wrong!',
  soho_marketplace_licence_details_request_loading_modal_title: 'Purchasing…',
  soho_marketplace_licence_details_request_quick_action_modal_description: 'Are you sure you want to request %1$s licence?',
  soho_marketplace_licence_details_request_quick_action_modal_primary_button_title: 'Confirm',
  soho_marketplace_licence_details_request_quick_action_modal_secondary_button_title: 'Cancel',
  soho_marketplace_licence_details_request_quick_action_modal_title: 'Request licence',
  soho_marketplace_licence_details_request_success_modal_description: 'Your request has been sent to the admin.',
  soho_marketplace_licence_details_request_success_modal_extra_text: 'You will receive a confirmation notification shortly.',
  soho_marketplace_licence_details_request_success_modal_primary_button_title: 'Return to marketplace',
  soho_marketplace_licence_details_request_success_modal_title: 'Congratulations!',
  soho_marketplace_licence_details_stepper_licence_title: 'Licence',
  soho_marketplace_licence_details_stepper_summary_title: 'Summary',
  soho_marketplace_licence_details_stepper_your_plan_title: 'Your plan',
  soho_marketplace_licence_details_summary_header_description: 'We are nearly done, all that’s left is to review the details and confirm your purchase…',
  soho_marketplace_licence_details_summary_header_title: 'Summary',
  soho_marketplace_licence_details_title: 'Licence details',
  soho_marketplace_licence_sub_header_manage_btn: 'Manage',
  soho_marketplace_pdp_purchase_successful_overlay_primary_button_text: 'Products details',
  soho_marketplace_pdp_purchase_successful_overlay_purchase_description: 'You can manage these licences and assign them to your employees, or go back to the marketplace.',
  soho_marketplace_pdp_purchase_successful_overlay_purchase_details: 'You’ve purchased %1$s %2$s licences with the %3$s plan selected.',
  soho_marketplace_pdp_purchase_successful_overlay_secondary_button_text: 'Back to marketplace',
  soho_marketplace_pdp_purchase_successful_overlay_title: 'Congratulations!',
  soho_marketplace_pdp_purchase_summary_addons_subtitle: 'Add more Add-ons to your plan',
  soho_marketplace_pdp_purchase_summary_my_licence: 'My licence',
  soho_marketplace_pdp_purchase_summary_my_plan: 'My plan',
  soho_marketplace_pdp_purchase_summary_title: 'Summary',
  soho_marketplace_pdp_purchase_title: 'Purchase',
  soho_marketplace_pdp_summary_addon_breakdown_item_monthly_per_licence: 'Monthly / licence',
  soho_marketplace_pdp_summary_addon_breakdown_item_number_of_licence: 'Number of licences',
  soho_marketplace_pdp_summary_addon_breakdown_item_title: 'Add on',
  soho_marketplace_pdp_summary_addon_breakdown_item_total: 'Total',
  soho_marketplace_pdp_summary_addon_breakdown_item_yearly_per_licence: 'Yearly / licence',
  soho_marketplace_pdp_summary_addon_item_add_item: 'Add item',
  soho_marketplace_pdp_summary_addon_item_remove_item: 'Remove item',
  soho_marketplace_pdp_summary_addon_item_title: 'Plugin',
  soho_marketplace_pdp_summary_addons_breakdown_close_button_title: 'Close',
  soho_marketplace_pdp_summary_addons_breakdown_title: 'Add-ons cost breakdown',
  soho_marketplace_pdp_summary_addons_breakdown_total_to_pay: 'Total to pay',
  soho_marketplace_pdp_summary_addons_subtitle: 'Need a top up on your new package?',
  soho_marketplace_pdp_summary_addons_title: 'Add-ons',
  soho_marketplace_pdp_summary_cost: 'Cost',
  soho_marketplace_pdp_summary_cost_breakdown: 'Breakdown',
  soho_marketplace_pdp_summary_cost_breakdown_addons: 'Add-Ons',
  soho_marketplace_pdp_summary_cost_breakdown_addons_why_modal_description: 'Your first bill amount may be higher because it includes upfront licence and add-ons costs.',
  soho_marketplace_pdp_summary_cost_breakdown_addons_why_modal_question: 'Why %1$s on your first bill?',
  soho_marketplace_pdp_summary_cost_breakdown_addons_why_text: 'Why?',
  soho_marketplace_pdp_summary_cost_breakdown_amount: 'Amount',
  soho_marketplace_pdp_summary_cost_breakdown_amount_value: '%1$s licences',
  soho_marketplace_pdp_summary_cost_breakdown_confirm_payment: 'Confirm',
  soho_marketplace_pdp_summary_cost_breakdown_duration: 'Duration',
  soho_marketplace_pdp_summary_cost_breakdown_duration_monthly: 'Rolling monthly subscription',
  soho_marketplace_pdp_summary_cost_breakdown_duration_yearly: 'Rolling yearly subscription',
  soho_marketplace_pdp_summary_cost_breakdown_return_policy_hyperlink: 'return policy',
  soho_marketplace_pdp_summary_cost_breakdown_start_date: 'Start date',
  soho_marketplace_pdp_summary_cost_breakdown_start_date_today: 'Today',
  soho_marketplace_pdp_summary_cost_breakdown_terms_description: 'By tapping ‘Confirm’, you accept our terms and conditions. See %1$s and %2$s.',
  soho_marketplace_pdp_summary_cost_breakdown_terms_hyperlink: 'terms and conditions',
  soho_marketplace_pdp_summary_cost_breakdown_then_monthly: 'Then monthly',
  soho_marketplace_pdp_summary_cost_breakdown_then_yearly: 'Then yearly',
  soho_marketplace_pdp_summary_cost_breakdown_upfront: 'Upfront',
  soho_marketplace_pdp_summary_cost_note: 'The price will be added to your next bill',
  soho_marketplace_pdp_summary_cost_per_month: 'per month',
  soho_marketplace_pdp_summary_cost_per_year: 'per year',
  soho_marketplace_pdp_summary_cost_upfront: 'upfront',
  soho_marketplace_pdp_summary_inc_vat: 'inc VAT',
  soho_marketplace_pdp_summary_quantity: 'Quantity',
  soho_marketplace_pdp_summary_your_licence: 'Your licence',
  soho_marketplace_pdp_summary_your_plan: 'Your plan',
  soho_marketplace_pdp_total_cost: 'Total cost',
  soho_marketplace_pdp_total_cost_first_bill_title: 'First bill',
  soho_marketplace_pdp_total_cost_licence_title: 'Licence',
  soho_marketplace_pdp_total_cost_on_confirm_instructions: 'By tapping ‘Confirm’, you accept our terms and conditions. See return policy and terms and conditions.',
  soho_marketplace_pdp_total_cost_subtitle: 'This price will be added to your next bill',
  soho_marketplace_pdp_your_plan_choose_this_plan: 'Choose this plan',
  soho_marketplace_pdp_your_plan_other_plans: 'Other plans',
  soho_marketplace_pdp_your_plan_plans: 'Plans',
  soho_marketplace_pdp_your_plan_recommended_for_you: 'Recommended for you',
  soho_marketplace_pdp_your_plan_this_includes: 'This includes',
  soho_marketplace_pdp_your_plan_why_package_is_perfect: 'Why is this package perfect for me?',
  soho_marketplace_purchase_choose_this_plan_title: 'Choose this plan',
  soho_marketplace_purchase_compare_plans_title: 'Compare plans',
  soho_marketplace_purchase_my_plan_sub_title: 'Selected plan',
  soho_marketplace_purchase_my_plan_title: 'My plan',
  soho_marketplace_purchase_other_plans_sub_title: 'Other plans',
  soho_marketplace_purchase_plan_step_title: 'Plan',
  soho_marketplace_purchase_recommend_for_you_title: 'Recommended for you',
  soho_marketplace_purchase_summary_step_title: 'Summary',
  soho_marketplace_purchase_why_this_plan_title: 'Why this plan is perfect for me?',
  soho_marketplace_recommended_for_you_header_subtitle: '%1$s applications',
  soho_marketplace_recommended_for_you_header_title: 'Applications overview',
  soho_marketplace_recommended_for_you_page_title: 'Applications',
  soho_marketplace_recommended_for_you_show_more: 'Show more',
  soho_marketplace_recommended_for_you_subtitle: 'Recommended for you',
  soho_marketplace_search_placeholder: 'Search contact',
  soho_multiple_requests_approve_addon_primary_button_title: 'Manage addons',
  soho_multiple_requests_approve_addon_quick_action_description: 'Please confirm you would like to assign the add on ‘%1$s’ to the selected users',
  soho_multiple_requests_approve_addon_success_modal_description: 'You’ve assigned the add on for ‘%1$s’ to the selected users',
  soho_multiple_requests_approve_addon_success_modal_extra_text: 'You can continue to manage addons for this application, or go back and manage other requests.',
  soho_multiple_requests_approve_addon_success_modal_subtitle: 'The users will receive a confirmation message when they next log in',
  soho_multiple_requests_approve_device_primary_button_title: 'Manage devices',
  soho_multiple_requests_approve_device_quick_action_description: 'Please confirm you would like to assign a device for ‘%1$s’ to the selected users',
  soho_multiple_requests_approve_device_success_modal_description: 'You’ve assigned the device for ‘%1$s’ to the selected users',
  soho_multiple_requests_approve_device_success_modal_extra_text: 'You can continue to manage devices for this application, or go back and manage other requests.',
  soho_multiple_requests_approve_device_success_modal_subtitle: 'The users will receive a confirmation message when they next log in',
  soho_multiple_requests_approve_licence_primary_button_title: 'Manage licences',
  soho_multiple_requests_approve_licence_quick_action_description: 'Please confirm you would like to assign licence for ‘%1$s’ to the selected users',
  soho_multiple_requests_approve_licence_success_modal_description: 'You’ve assigned the licence for ‘%1$s’ to the selected users',
  soho_multiple_requests_approve_licence_success_modal_subtitle: 'The users will receive a confirmation message when they next log in',
  soho_multiple_requests_approve_license_success_modal_extra_text: 'You can continue to manage licences for this application, or go back and manage other requests.',
  soho_multiple_requests_approve_secondary_button_title: 'Back to requests',
  soho_multiple_requests_reject_addon_primary_button_title: 'Manage addons',
  soho_multiple_requests_reject_addon_quick_action_description: 'You have chosen to reject the add on request for ‘%1$s’ for the selected users',
  soho_multiple_requests_reject_addon_success_modal_description: 'You’ve rejected user requests for ‘%1$s’',
  soho_multiple_requests_reject_addon_success_modal_subtitle: 'The users will receive a notification message when they next log in',
  soho_multiple_requests_reject_device_primary_button_title: 'Manage devices',
  soho_multiple_requests_reject_device_quick_action_description: 'You have chosen to reject the device request for ‘%1$s’ for the selected users',
  soho_multiple_requests_reject_device_success_modal_description: 'You’ve rejected user requests for ‘%1$s’',
  soho_multiple_requests_reject_device_success_modal_subtitle: 'The users will receive a notification message when they next log in',
  soho_multiple_requests_reject_licence_primary_button_title: 'Manage licences',
  soho_multiple_requests_reject_licence_quick_action_description: 'You have chosen to reject the licence request for ‘%1$s’ for the selected users',
  soho_multiple_requests_reject_licence_success_modal_description: 'You’ve rejected user requests for ‘%1$s’',
  soho_multiple_requests_reject_licence_success_modal_subtitle: 'The users will receive a notification message when they next log in',
  soho_multiple_requests_secondary_button_title: 'Back to requests',
  soho_my_plan_tile_number_of_user_format: '%1$s user',
  soho_my_plan_tile_number_of_users_format: '%1$s users',
  soho_my_plan_tile_title: 'My plan',
  soho_my_plans_request_usage_calls_label: 'Request Calls',
  soho_my_plans_request_usage_calls_title: 'Request mins',
  soho_my_plans_request_usage_data_label: 'Request Data',
  soho_my_plans_request_usage_data_title: 'Request data',
  soho_my_plans_request_usage_sms_label: 'Request SMS',
  soho_my_plans_request_usage_sms_title: 'Request SMS',
  soho_my_profile_addon_failure_error_message: 'An error has occurred and we’re having some trouble loading your content.',
  soho_my_profile_addons: 'Addons',
  soho_my_profile_addons_cancel_request_button_label: 'Cancel request',
  soho_my_profile_addons_my_addons_label: 'My Add-ons',
  soho_my_profile_addons_request_new_addon_button_label: 'Request this Add-on',
  soho_my_profile_addons_requested_addons_empty_text: '%1$s doesn’t have any requested Add-ons. Tap on Request Add-ons to shop.',
  soho_my_profile_addons_requested_addons_title: 'Requested Add-ons',
  soho_my_profile_addons_view_requests_label: 'View requests',
  soho_my_profile_devices: 'Devices',
  soho_my_profile_header: 'Cost per month',
  soho_my_profile_licences: 'Licences',
  soho_my_profile_plans: 'My Plan',
  soho_my_profile_requested_addon_empty_text: 'You don’t have any requested Add-ons. Tap on Request Add-ons to shop.',
  soho_my_profile_sub_header: '%1$s added to your bill',
  soho_my_profile_title: '%1$s\'s work phone',
  soho_my_profile_usage: 'Usage',
  soho_my_requests_title: 'My requests',
  soho_my_users_and_groups_add_group_text: 'Add group',
  soho_my_users_and_groups_empty_groups_btn: 'Create a group',
  soho_my_users_and_groups_empty_groups_sub_title: 'We will add the information here as soon as you create your first group.',
  soho_my_users_and_groups_empty_groups_title: 'You don’t have any groups set up',
  soho_my_users_and_groups_empty_users_description_text: 'We will add the information here as soon as you add your users.',
  soho_my_users_and_groups_empty_users_title_text: 'You don’t have available users',
  soho_my_users_and_groups_error_add_group: 'Sorry, this group name already exists',
  soho_my_users_and_groups_groups_tab_title: 'Groups',
  soho_my_users_and_groups_groups_title: 'Manage groups',
  soho_my_users_and_groups_manage_group_confirm: 'Confirm',
  soho_my_users_and_groups_manage_group_header_subtitle: 'Manage the users within this group',
  soho_my_users_and_groups_manage_group_header_title: 'Groups',
  soho_my_users_and_groups_manage_group_show_less: 'Show less',
  soho_my_users_and_groups_manage_group_show_more: 'Show more',
  soho_my_users_and_groups_manage_group_title: 'Manage group',
  soho_my_users_and_groups_manage_group_users_outside_group: 'Users outside group',
  soho_my_users_and_groups_manage_group_users_within_group: 'Users within group',
  soho_my_users_and_groups_manage_group_users_within_group_empty_text: 'You have no users available to assign. You can add users by selecting from the users outside of group section.',
  soho_my_users_and_groups_screen_title: 'Account',
  soho_my_users_and_groups_subtitle: 'Filter or search for direct access to user profiles',
  soho_my_users_and_groups_title: 'My users',
  soho_my_users_and_groups_users_administrators: 'Administrators',
  soho_my_users_and_groups_users_search_placeholder: 'Search…',
  soho_my_users_and_groups_users_show_less: 'Show less',
  soho_my_users_and_groups_users_show_more: 'Show more',
  soho_my_users_and_groups_users_standard: 'Standard users',
  soho_my_users_and_groups_users_subtitle: 'Members of your business',
  soho_my_users_and_groups_users_tab_title: 'Users',
  soho_my_users_and_groups_users_title: 'Manage users',
  soho_my_users_and_groups_your_groups_text: 'Your groups',
  soho_my_users_and_groups_your_groups_users_count_text: '%1$s users',
  soho_overtime_users_title: 'Overtime',
  soho_plan_info_quick_view_data_text: 'Data',
  soho_plan_info_quick_view_description: 'Your plan breakdown',
  soho_plan_info_quick_view_mins_text: 'Mins',
  soho_plan_info_quick_view_monthly_cost_text: 'Monthly cost',
  soho_plan_info_quick_view_no_of_users_text: 'No. of users',
  soho_plan_info_quick_view_plan_text: 'Plan',
  soho_plan_info_quick_view_qam_close_btn_text: 'Close',
  soho_plan_info_quick_view_sms_text: 'SMS',
  soho_plan_info_quick_view_title: 'Plan info',
  soho_plan_info_quick_view_total_monthly_text: 'Monthly',
  soho_plan_info_quick_view_total_to_pay_text: 'Total to pay',
  soho_plan_info_quick_view_unlimited_text: 'Unlimited',
  soho_plan_single_plan_title: 'Manage Plan',
  soho_plans_active_plan_card_label: 'Active',
  soho_plans_active_service_subtitle_text: 'Active service',
  soho_plans_add_or_remove_user_failure_modal_close: 'Close',
  soho_plans_add_or_remove_user_failure_modal_description: 'Unfortunately we were unable to process your request.',
  soho_plans_add_or_remove_user_failure_modal_title: 'Something went wrong!',
  soho_plans_add_or_remove_user_failure_modal_try_again: 'Try again',
  soho_plans_add_usage_calls_choose_amount_title: 'Choose the amount',
  soho_plans_add_usage_calls_choose_occurrence_title: 'Choose occurrence of extra mins',
  soho_plans_add_usage_calls_occurrence_first_option_title: 'One off',
  soho_plans_add_usage_calls_occurrence_second_option_title: 'Recurring',
  soho_plans_add_usage_calls_one_off_payment_statement: 'Changes are not added to your monthly bill. Any un-used mins allowance can continue to be used until your plan refreshes.',
  soho_plans_add_usage_calls_recurring_payment_statement: 'Changes are not added to your monthly bill. Any un-used mins allowance can continue to be used until your plan refreshes.',
  soho_plans_add_usage_calls_title: 'Add mins to your plan',
  soho_plans_add_usage_cancel_button_title: 'Cancel',
  soho_plans_add_usage_confirm_button_title: 'Confirm',
  soho_plans_add_usage_data_choose_amount_title: 'Choose the amount',
  soho_plans_add_usage_data_choose_occurrence_title: 'Choose occurrence of extra data',
  soho_plans_add_usage_data_occurrence_first_option_title: 'One off',
  soho_plans_add_usage_data_occurrence_second_option_title: 'Recurring',
  soho_plans_add_usage_data_one_off_payment_statement: 'Changes are not added to your monthly bill. Any un-used data allowance can continue to be used until your plan refreshes.',
  soho_plans_add_usage_data_recurring_payment_statement: 'Changes are not added to your monthly bill. Any un-used data allowance can continue to be used until your plan refreshes.',
  soho_plans_add_usage_data_title: 'Add data to your plan',
  soho_plans_add_usage_quick_action_loading: 'Processing…',
  soho_plans_add_usage_result_failure_go_back_button_title: 'Go back',
  soho_plans_add_usage_result_failure_try_again_button_title: 'Try again',
  soho_plans_add_usage_result_success_message: 'You\'ve added an extra %1$s%2$s to the plan',
  soho_plans_add_usage_result_success_message_with_plan: 'You have successfully added %1$s%2$s extra to your %3$s plan.',
  soho_plans_add_usage_result_success_return_button_title: 'Return to Plans',
  soho_plans_add_usage_result_success_title: 'Congratulations!',
  soho_plans_add_usage_sms_choose_amount_title: 'Choose the amount',
  soho_plans_add_usage_sms_choose_occurrence_title: 'Choose occurrence of extra SMS',
  soho_plans_add_usage_sms_occurrence_first_option_title: 'One off',
  soho_plans_add_usage_sms_occurrence_second_option_title: 'Recurring',
  soho_plans_add_usage_sms_one_off_payment_statement: 'Changes are not added to your monthly bill. Any un-used SMS allowance can continue to be used until your plan refreshes.',
  soho_plans_add_usage_sms_recurring_payment_statement: 'Changes are not added to your monthly bill. Any un-used SMS allowance can continue to be used until your plan refreshes.',
  soho_plans_add_usage_sms_title: 'Add SMS to your plan',
  soho_plans_add_usage_user_result_success_message: 'You have requested %1$s%2$s extra to your plan and it has been sent to the chooser.',
  soho_plans_add_user_cancel_button_title: 'Cancel',
  soho_plans_add_user_card_title: 'Manage users',
  soho_plans_add_user_confirm_button_title: 'Confirm',
  soho_plans_add_user_plan_assigned_users_title: 'Users on this plan',
  soho_plans_add_user_plan_empty_assigned_users: 'You have no users on this plan. You can add users by selecting from the users without a plan section.',
  soho_plans_add_user_plan_empty_unassigned_users: 'You have no users without a plan. When you remove a user from above, it will be shown here.',
  soho_plans_add_user_plan_no_assigned_users: 'There are currently no users on this plan',
  soho_plans_add_user_plan_no_unassigned_users: 'There are currently no users without a plan',
  soho_plans_add_user_plan_unassigned_user_current_count: '%1$s user without a plan',
  soho_plans_add_user_plan_unassigned_users_current_count: '%1$s users without a plan',
  soho_plans_add_user_plan_unassigned_users_title: 'Users without a plan',
  soho_plans_add_user_plan_user_current_count: '%1$s user on this plan',
  soho_plans_add_user_plan_users_current_count: '%1$s users on this plan',
  soho_plans_add_user_quick_action_cancel_button_title: 'Cancel',
  soho_plans_add_user_quick_action_confirm_button_title: 'Confirm',
  soho_plans_add_user_quick_action_description: 'Please confirm you would like to add this user to the plan?',
  soho_plans_add_user_quick_action_title: 'Adding user to plan',
  soho_plans_add_user_remove_button_title: 'Remove',
  soho_plans_add_user_section_title: 'Add users to plan',
  soho_plans_add_user_select_all_button_title: 'Select all',
  soho_plans_add_user_subtitle: '%1$s monthly cost',
  soho_plans_add_user_success_modal_description: 'The user has been successfully added to the plan',
  soho_plans_add_user_success_modal_description_plural: 'The users have been successfully added to the plan',
  soho_plans_add_user_success_modal_plan_name_description: 'This user has successfully been added to the %1$s plan.',
  soho_plans_add_user_success_modal_return_to_dashboard: 'Dashboard',
  soho_plans_add_user_success_modal_return_to_plan: 'Return to Plan',
  soho_plans_add_user_success_modal_subtitle: 'You can continue to the plan overview or go back to the dashboard',
  soho_plans_add_user_success_modal_title: 'Congratulations!',
  soho_plans_add_user_title: 'Users',
  soho_plans_add_users_loading_modal_description: 'Adding users…',
  soho_plans_add_users_quick_action_description: 'Please confirm you would like to add these users to the plan?',
  soho_plans_add_users_quick_action_number_of_users: 'No. of users',
  soho_plans_add_users_quick_action_plan_per_user_per_month: 'Plan/user/month',
  soho_plans_add_users_quick_action_plan_total: 'Total',
  soho_plans_add_users_quick_action_plan_total_cost: 'Total Cost',
  soho_plans_add_users_quick_action_price_based_on: 'Based on 1 plan',
  soho_plans_add_users_quick_action_price_cost: 'Total cost',
  soho_plans_add_users_quick_action_price_include_vat: 'inc VAT',
  soho_plans_add_users_quick_action_title: 'Adding users to plan',
  soho_plans_add_users_success_modal_plan_name_description: 'these users has successfully been added to the %1$s plan.',
  soho_plans_add_users_success_modal_return_to_business_overview: 'Business overview',
  soho_plans_add_users_success_modal_return_to_plans: 'Return to Plans',
  soho_plans_add_users_success_modal_title: 'Congratulations!',
  soho_plans_dates_format: 'dd/MM/yyyy',
  soho_plans_failure_error_message: 'An error has occurred and we’re having some trouble loading your content.',
  soho_plans_failure_try_again: 'Try again',
  soho_plans_inactive_plan_card_label: 'Inactive',
  soho_plans_inactive_service_subtitle_text: 'Inactive service',
  soho_plans_plan_add_calls_button_label: 'Add Minutes',
  soho_plans_plan_add_data_button_label: 'Add Data',
  soho_plans_plan_add_sms_button_label: 'Add SMS',
  soho_plans_plan_add_user_label: 'Users',
  soho_plans_plan_card_calls_label: 'Calls',
  soho_plans_plan_card_consumption: '%1$s/%2$s',
  soho_plans_plan_card_contract_data_contract_ends_label: 'Contract ends on',
  soho_plans_plan_card_contract_data_eligible_upgrade_from_label: 'Eligible to upgrade from',
  soho_plans_plan_card_contract_data_minimum_term_ends_label: 'Minimum term ends on',
  soho_plans_plan_card_contract_data_renewal_date_label: 'Renewal date',
  soho_plans_plan_card_data_label: 'Data',
  soho_plans_plan_card_price_includes_vat: 'inc VAT',
  soho_plans_plan_card_price_label: 'Price per month',
  soho_plans_plan_card_show_less: 'Show less',
  soho_plans_plan_card_show_more: 'Show more',
  soho_plans_plan_card_sms_label: 'SMS',
  soho_plans_plan_card_title: '%1$s plan',
  soho_plans_plan_card_unlimited_consumption: 'Unlimited',
  soho_plans_plan_card_upgrade_plan: 'Upgrade plan',
  soho_plans_plan_card_usage_details_separator: 'left of',
  soho_plans_plan_card_usage_details_value: '%1$s left of %2$s',
  soho_plans_plan_card_view_plan: 'View plan',
  soho_plans_plan_consumption: '%1$s used this month',
  soho_plans_plan_error_try_again: 'Try again',
  soho_plans_plan_header_reset_in_day: 'Resets in %1$s day',
  soho_plans_plan_header_reset_in_days: 'Resets in %1$s days',
  soho_plans_plan_left: '%1$s left in this month',
  soho_plans_plan_unlimited_consumption: 'Unlimited',
  soho_plans_plan_user_card_remove_label: 'Remove',
  soho_plans_plan_user_card_view_profile_label: 'View profile',
  soho_plans_plan_users_title: 'Users on this plan',
  soho_plans_refresh_header_button_updated_just_now: 'Updated just now',
  soho_plans_refresh_header_button_updated_min_ago: 'Updated %1$smin ago',
  soho_plans_refresh_header_button_updating: 'Updating…',
  soho_plans_remove_user_loading_modal_description: 'Removing user…',
  soho_plans_remove_user_quick_action_cancel_button_title: 'Cancel',
  soho_plans_remove_user_quick_action_confirm_button_title: 'Confirm',
  soho_plans_remove_user_quick_action_description: 'Would you like to remove this user from the plan?',
  soho_plans_remove_user_quick_action_title: 'Removing user from plan',
  soho_plans_remove_user_success_modal_description: 'The user has been successfully removed from the plan',
  soho_plans_remove_user_success_modal_plan_name_description: 'The user has been successfully removed from %1$s',
  soho_plans_remove_user_success_modal_title: 'Plan updated!',
  soho_plans_request_usage_result_success_button_title: 'Return to My Plan',
  soho_plans_request_usage_result_success_message: 'You have requested %1$s%2$s extra to your plan and it has been sent to the chooser.',
  soho_plans_section_title: '%1$s service',
  soho_plans_sub_header_description_title: '%1$s monthly cost',
  soho_plans_sub_header_title: '%1$s users',
  soho_plans_tile_failure_error_message: 'An error has occurred',
  soho_plans_tile_failure_try_again: 'Try again',
  soho_plans_title: 'Plans',
  soho_plans_user_per_plan: '%1$s user on this plan',
  soho_plans_users_per_plan: '%1$s users on this plan',
  soho_products_and_services_screen_all_products_no: 'All products %1$s',
  soho_products_and_services_screen_other: 'Other',
  soho_products_and_services_screen_subtitle: 'My products',
  soho_products_and_services_screen_title: 'Products & services',
  soho_profile_addons_buy_addon_button_buy_this_addon_label: 'Buy this add on',
  soho_profile_addons_buy_quick_action_description: 'Are you sure you want to buy %1$s add-on?',
  soho_profile_addons_buy_quick_action_hint: 'User will be able to use this add-on starting today.',
  soho_profile_addons_cancel_request_quick_action_description: 'Are you sure you want to cancel your request for %1$s add-on?',
  soho_profile_addons_remove_addon_button_apply_changes_label: 'Remove',
  soho_profile_addons_remove_addon_secondary_button_back_to_addons_label: 'Back to addons',
  soho_profile_addons_remove_quick_action_description: 'Are you sure you want to remove %1$s add-on?',
  soho_profile_addons_remove_quick_action_hint: 'User will still be able to use this add-on until %1$s',
  soho_profile_addons_request_quick_action_description: 'Are you sure you want to request %1$s add-on?',
  soho_profile_addons_request_quick_action_hint: 'You will be able to use this add-on once request is granted',
  soho_profile_addons_table_title: '%1$s\'s Add-ons',
  soho_profile_management_account_error_try_again: 'Try again',
  soho_profile_management_account_failure_error_message: 'An error has occurred and we’re having some trouble loading your content.',
  soho_profile_management_account_number: 'Account no.',
  soho_profile_management_active_current_licences: 'Active current licences',
  soho_profile_management_cvm_page_banner_add_ons_description_plural: 'Would you like to review these?',
  soho_profile_management_cvm_page_banner_add_ons_description_singular: 'Would you like to review this?',
  soho_profile_management_cvm_page_banner_add_ons_primary_button_title: 'Yes please',
  soho_profile_management_cvm_page_banner_add_ons_title_plural: '%1$s has %2$s active add on requests',
  soho_profile_management_cvm_page_banner_add_ons_title_singular: '%1$s has %2$s active add on request',
  soho_profile_management_cvm_page_banner_licence_description_plural: 'Would you like to view these requests?',
  soho_profile_management_cvm_page_banner_licence_description_singular: 'Would you like to review this request?',
  soho_profile_management_cvm_page_banner_licence_title_plural: '%1$s has %2$s pending licence requests',
  soho_profile_management_cvm_page_banner_licence_title_singular: '%1$s has %2$s pending licence request',
  soho_profile_management_cvm_page_banner_plans_description: 'Would you like to view this recommended plan?',
  soho_profile_management_cvm_page_banner_plans_title: 'Based on %1$s’s current usage, we recommend an alternative plan',
  soho_profile_management_licences_include_vat: 'inc VAT',
  soho_profile_management_no_results_found: 'Sorry, we couldn’t find any results.',
  soho_profile_management_remove_addons_expiration_date_label: 'Expiration date',
  soho_profile_management_title: 'Profile',
  soho_profile_management_user_details_addons: 'Addons',
  soho_profile_management_user_details_devices: 'Devices',
  soho_profile_management_user_details_licences: 'Licences',
  soho_profile_management_user_details_plans: 'Plans',
  soho_profile_management_user_details_usage: 'Usage',
  soho_profile_plans_section_subtitle: 'Primary service',
  soho_profile_plans_section_title: 'Active services',
  soho_profile_requested_addon_details_back_to_addons_label: 'Back to add ons',
  soho_recent_tray_no_of_licences: '%1$s licences',
  soho_recent_tray_no_of_users: '%1$s users',
  soho_requests_application_components_image_title: 'This includes',
  soho_requests_approve_addon_failure_modal_description: 'Unfortunately we were unable to process your request.',
  soho_requests_approve_addon_failure_modal_title: 'Something went wrong!',
  soho_requests_approve_addon_failure_modal_try_again: 'Try again',
  soho_requests_approve_addon_quick_action_cancel_button_title: 'Cancel',
  soho_requests_approve_addon_quick_action_confirm_button_title: 'Confirm',
  soho_requests_approve_addon_quick_action_description: 'Please confirm you would like to assign the add on ‘%1$s’ to the selected user',
  soho_requests_approve_addon_quick_action_title: 'Assigning add on',
  soho_requests_approve_addon_success_modal_description: 'You’ve assigned the add on for ‘%1$s’ to the selected user',
  soho_requests_approve_addon_success_modal_primary_button_title: 'Back to requests',
  soho_requests_approve_addon_success_modal_subtitle: 'The user will receive a confirmation message when they next log in',
  soho_requests_approve_addon_success_modal_title: 'Congratulations!',
  soho_requests_approve_device_failure_modal_description: 'Unfortunately we were unable to process your request.',
  soho_requests_approve_device_failure_modal_title: 'Something went wrong!',
  soho_requests_approve_device_failure_modal_try_again: 'Try again',
  soho_requests_approve_device_quick_action_cancel_button_title: 'Cancel',
  soho_requests_approve_device_quick_action_confirm_button_title: 'Confirm',
  soho_requests_approve_device_quick_action_description: 'Please confirm you would like to assign a device for ‘%1$s’ to the selected user',
  soho_requests_approve_device_quick_action_title: 'Assigning available user device',
  soho_requests_approve_device_success_modal_description: 'You’ve assigned the device for ‘%1$s’ to the selected user',
  soho_requests_approve_device_success_modal_primary_button_title: 'Back to requests',
  soho_requests_approve_device_success_modal_subtitle: 'The user will receive a confirmation message when they next log in',
  soho_requests_approve_device_success_modal_title: 'Congratulations!',
  soho_requests_approve_licence_failure_modal_description: 'Unfortunately we were unable to process your request.',
  soho_requests_approve_licence_failure_modal_title: 'Something went wrong!',
  soho_requests_approve_licence_failure_modal_try_again: 'Try again',
  soho_requests_approve_licence_quick_action_cancel_button_title: 'Cancel',
  soho_requests_approve_licence_quick_action_confirm_button_title: 'Confirm',
  soho_requests_approve_licence_quick_action_description: 'Please confirm you would like to assign a licence for ‘%1$s’ to the selected user',
  soho_requests_approve_licence_quick_action_title: 'Assigning available user licence',
  soho_requests_approve_licence_success_modal_description: 'You’ve assigned the licence for ‘%1$s’ to the selected user',
  soho_requests_approve_licence_success_modal_primary_button_title: 'Back to requests',
  soho_requests_approve_licence_success_modal_subtitle: 'The user will receive a confirmation message when they next log in',
  soho_requests_approve_licence_success_modal_title: 'Congratulations!',
  soho_requests_approve_request_confirmation_dialog_price_title: 'Total cost',
  soho_requests_cancel_addon_failure_modal_description: 'Unfortunately we were unable to process your request. Please try again later.',
  soho_requests_cancel_addon_failure_modal_title: 'Something went wrong!',
  soho_requests_cancel_addon_failure_modal_try_again: 'Try again',
  soho_requests_cancel_addon_quick_action_cancel_button_title: 'Cancel',
  soho_requests_cancel_addon_quick_action_confirm_button_title: 'Confirm',
  soho_requests_cancel_addon_quick_action_description: 'Please confirm you would like to cancel your addon for ‘%1$s’',
  soho_requests_cancel_addon_quick_action_title: 'Cancel addon request',
  soho_requests_cancel_addon_success_modal_description: 'You’ve cancelled your request for ‘%1$s’',
  soho_requests_cancel_addon_success_modal_primary_button_title: 'Back to requests',
  soho_requests_cancel_addon_success_modal_subtitle: 'You will receive a confirmation notification shortly',
  soho_requests_cancel_addon_success_modal_title: 'Action complete!',
  soho_requests_cancel_device_failure_modal_description: 'Unfortunately we were unable to process your request. Please try again later.',
  soho_requests_cancel_device_failure_modal_title: 'Something went wrong!',
  soho_requests_cancel_device_failure_modal_try_again: 'Try again',
  soho_requests_cancel_device_quick_action_cancel_button_title: 'Cancel',
  soho_requests_cancel_device_quick_action_confirm_button_title: 'Confirm',
  soho_requests_cancel_device_quick_action_description: 'Please confirm you would like to cancel your device request for ‘%1$s’',
  soho_requests_cancel_device_quick_action_title: 'Cancel device request',
  soho_requests_cancel_device_success_modal_description: 'You’ve cancelled your request for ‘%1$s’',
  soho_requests_cancel_device_success_modal_primary_button_title: 'Back to requests',
  soho_requests_cancel_device_success_modal_subtitle: 'You will receive a confirmation notification shortly',
  soho_requests_cancel_device_success_modal_title: 'Action complete!',
  soho_requests_cancel_licence_failure_modal_description: 'Unfortunately we were unable to process your request. Please try again later.',
  soho_requests_cancel_licence_failure_modal_title: 'Something went wrong!',
  soho_requests_cancel_licence_failure_modal_try_again: 'Try again',
  soho_requests_cancel_licence_quick_action_cancel_button_title: 'Cancel',
  soho_requests_cancel_licence_quick_action_confirm_button_title: 'Confirm',
  soho_requests_cancel_licence_quick_action_description: 'Please confirm you would like to cancel your licence request for ‘%1$s’',
  soho_requests_cancel_licence_quick_action_title: 'Cancel licence request',
  soho_requests_cancel_licence_success_modal_description: 'You’ve cancelled your request for ‘%1$s’',
  soho_requests_cancel_licence_success_modal_primary_button_title: 'Back to requests',
  soho_requests_cancel_licence_success_modal_subtitle: 'You will receive a confirmation notification shortly',
  soho_requests_cancel_licence_success_modal_title: 'Action complete!',
  soho_requests_cancel_request_quick_action_cancel_button_title: 'Cancel',
  soho_requests_cancel_request_quick_action_confirm_button_title: 'Confirm',
  soho_requests_cancel_request_success_modal_primary_button_title: 'Back to requests',
  soho_requests_cancel_request_success_modal_subtitle: 'You will receive a confirmation notification shortly',
  soho_requests_dates_format: 'dd.MM.yyyy',
  soho_requests_failure_modal_cancel_button_title: 'Cancel',
  soho_requests_failure_modal_title: 'Something went wrong!',
  soho_requests_failure_modal_try_again_button_title: 'Try again',
  soho_requests_filter_addons: 'Add-ons',
  soho_requests_filter_devices: 'Devices',
  soho_requests_filter_licences: 'Licences',
  soho_requests_filter_see_all: 'See all',
  soho_requests_full_failure_error_message: 'An error has occurred and we’re having some trouble loading your content.',
  soho_requests_full_failure_error_try_again: 'Try again',
  soho_requests_licences_used_count_format: '%1$s licences used',
  soho_requests_modal_loading_screen_subtitle: 'Processing…',
  soho_requests_past_error_message: 'An error has occurred and we’re having some trouble loading your content.',
  soho_requests_past_error_try_again_button_title: 'Try again',
  soho_requests_past_requests_approved_at: 'Approved %1$s',
  soho_requests_past_requests_cancelled_at: 'Cancelled %1$s',
  soho_requests_past_requests_rejected_at: 'Rejected %1$s',
  soho_requests_past_tab_title: 'Past',
  soho_requests_past_title: 'Past requests',
  soho_requests_pending_approve_button: 'Approve',
  soho_requests_pending_approve_upgrade_button: 'Approve upgrade',
  soho_requests_pending_cancel_request_button: 'Cancel request',
  soho_requests_pending_manage_requests_button: 'Manage Requests',
  soho_requests_pending_reject_button: 'Reject',
  soho_requests_pending_reject_message_remaining: '%1$s characters remaining',
  soho_requests_pending_requests_count: '%1$s pending requests',
  soho_requests_pending_requests_requested_at: 'Requested %1$s',
  soho_requests_pending_requests_requested_device_upgrade_from: 'Upgrade from',
  soho_requests_pending_requests_upgrade_requested_at: 'Upgrade requested %1$s',
  soho_requests_pending_tab_title: 'Pending',
  soho_requests_pending_title: 'Active requests',
  soho_requests_refresh_title_updated_just_now: 'Updated just now',
  soho_requests_refresh_title_updated_min_ago: 'Updated %1$smin ago',
  soho_requests_refresh_title_updating: 'Updating…',
  soho_requests_reject_addon_failure_modal_description: 'Unfortunately we were unable to process your request.',
  soho_requests_reject_addon_failure_modal_title: 'Something went wrong!',
  soho_requests_reject_addon_failure_modal_try_again: 'Try again',
  soho_requests_reject_addon_quick_action_cancel_button_title: 'Cancel',
  soho_requests_reject_addon_quick_action_confirm_button_title: 'Confirm',
  soho_requests_reject_addon_quick_action_description: 'You have chosen to reject the add on request for ‘%1$s’ for the selected user',
  soho_requests_reject_addon_quick_action_title: 'Rejecting an add on request',
  soho_requests_reject_addon_success_modal_description: 'You’ve rejected user request for ‘%1$s’',
  soho_requests_reject_addon_success_modal_primary_button_title: 'Back to requests',
  soho_requests_reject_addon_success_modal_subtitle: 'The user will receive a notification message when they next log in',
  soho_requests_reject_addon_success_modal_title: 'Action complete!',
  soho_requests_reject_device_failure_modal_description: 'Unfortunately we were unable to process your request.',
  soho_requests_reject_device_failure_modal_title: 'Something went wrong!',
  soho_requests_reject_device_failure_modal_try_again: 'Try again',
  soho_requests_reject_device_quick_action_cancel_button_title: 'Cancel',
  soho_requests_reject_device_quick_action_confirm_button_title: 'Confirm',
  soho_requests_reject_device_quick_action_description: 'You have chosen to reject the device request for ‘%1$s’ for the selected user',
  soho_requests_reject_device_quick_action_title: 'Rejecting a device request',
  soho_requests_reject_device_success_modal_description: 'You’ve rejected user requests for ‘%1$s’',
  soho_requests_reject_device_success_modal_primary_button_title: 'Back to requests',
  soho_requests_reject_device_success_modal_subtitle: 'The user will receive a notification message when they next log in',
  soho_requests_reject_device_success_modal_title: 'Action complete!',
  soho_requests_reject_licence_failure_modal_description: 'Unfortunately we were unable to process your request.',
  soho_requests_reject_licence_failure_modal_title: 'Something went wrong!',
  soho_requests_reject_licence_failure_modal_try_again: 'Try again',
  soho_requests_reject_licence_quick_action_cancel_button_title: 'Cancel',
  soho_requests_reject_licence_quick_action_confirm_button_title: 'Confirm',
  soho_requests_reject_licence_quick_action_description: 'You have chosen to reject the licence request for ‘%1$s’ for the selected user',
  soho_requests_reject_licence_quick_action_title: 'Rejecting a licence request',
  soho_requests_reject_licence_success_modal_description: 'You’ve rejected user requests for ‘%1$s’',
  soho_requests_reject_licence_success_modal_primary_button_title: 'Back to requests',
  soho_requests_reject_licence_success_modal_subtitle: 'The user will receive a notification message when they next log in',
  soho_requests_reject_licence_success_modal_title: 'Action complete!',
  soho_requests_reject_quick_action_placeholder: 'Enter a message (optional)',
  soho_requests_search_empty_view_message: 'There were no results for “%1$s”. Try a new search',
  soho_requests_search_placeholder: 'Search…',
  soho_requests_status_cancelled: 'Cancelled',
  soho_requests_status_completed: 'Approved',
  soho_requests_status_rejected: 'Rejected',
  soho_requests_updated_label_just_updated: 'Just updated',
  soho_requests_updated_label_minute: 'Updated %1$s min ago',
  soho_requests_updated_label_minutes: 'Updated %1$s mins ago',
  soho_requests_updated_label_timestamp: 'Updated %1$s',
  soho_requests_updated_label_updating: 'Updating…',
  soho_requests_view_details_button_title: 'View details',
  soho_search_bar_placeholder: 'Search here',
  soho_search_empty_view_message: 'Sorry, we couldn’t find any results.',
  soho_subtray_business_overview_section_button_text: 'Business overview',
  soho_subtray_business_overview_section_subtitle: '- %1$s users',
  soho_subtray_business_overview_section_title: 'My business',
  soho_usage_categories_description: 'How you’re using your data',
  soho_usage_categories_error_try_again: 'Try again',
  soho_usage_categories_filter_calls: 'Calls',
  soho_usage_categories_filter_data: 'Data',
  soho_usage_categories_filter_see_all: 'See all',
  soho_usage_categories_filter_sms: 'SMS',
  soho_usage_categories_graph_calls_subtitle: 'Calls:',
  soho_usage_categories_graph_data_subtitle: 'Data:',
  soho_usage_categories_graph_sms_subtitle: 'SMS:',
  soho_usage_categories_title: 'Categories',
  soho_usage_usage_card_consumption: '%1$s left of %2$s',
  soho_usage_usage_card_unlimited_consumption: 'Unlimited',
  soho_usage_users_description: 'How you’re using your data',
  soho_usage_users_error_try_again: 'Try again',
  soho_usage_users_title: 'Users',
  soho_usage_users_view_graphs_label: 'View graphs',
  soho_user_edit_add_ons_assigned_more_one_user: '%1$s users on this add on',
  soho_user_edit_add_ons_assigned_no_users: 'There are currently no users on this add on',
  soho_user_edit_add_ons_assigned_no_users_title: 'Users on this add on',
  soho_user_edit_add_ons_assigned_one_user: '%1$s user on this add on',
  soho_user_edit_add_ons_assigned_users_title: 'Users on this add-on',
  soho_user_edit_add_ons_confirm_button_title: 'Confirm',
  soho_user_edit_add_ons_empty_assigned_users: 'You have no users on this add-on. You can add users by selecting from the users without an add-on section.',
  soho_user_edit_add_ons_empty_unassigned_users: 'You have no users without an add-on. When you remove a user from above, it will be shown here.',
  soho_user_edit_add_ons_list_header: 'Manage users',
  soho_user_edit_add_ons_no_unassigned_users: 'There are currently no users without this add on',
  soho_user_edit_add_ons_product_id: 'Product ID: %1$s',
  soho_user_edit_add_ons_remove_user_title: 'Remove',
  soho_user_edit_add_ons_secondary_button: 'Cancel',
  soho_user_edit_add_ons_select_all_button_title: 'Select all',
  soho_user_edit_add_ons_show_less_title: 'Show less',
  soho_user_edit_add_ons_show_more_title: 'Show more',
  soho_user_edit_add_ons_title: 'Manage add ons',
  soho_user_edit_add_ons_un_assigned_more_one_user: '%1$s user without this add on',
  soho_user_edit_add_ons_unassigned_users_title: 'Users without this add-on',
  soho_user_edit_add_ons_unassigned_users_without_this_addon: '%1$s users without this add on',
  soho_user_edit_add_ons_unit_measure: '/%1$s',
  soho_user_permission_list_error_message: 'An error has occurred and we’re having some trouble loading your content.',
  soho_user_permission_list_error_try_again: 'Try again',
  soho_user_permission_list_loading_message: 'Processing…',
  soho_user_plan_tile_get_more_data_title: 'Get more Data',
  soho_user_plan_tile_get_more_mins_title: 'Get more mins',
  soho_user_plan_tile_get_more_sms_title: 'Get more SMSs',
  soho_user_plan_tile_left_of: 'left of your %1$s bundle',
  soho_user_plan_tile_reset_in_day: 'Resets in %1$s day',
  soho_user_plan_tile_reset_in_days: 'Resets in %1$s days',
  soho_user_plan_tile_top_title: '%1$s’s phone',
  soho_user_plan_tile_unlimited_description: 'Unlimited access',
  soho_user_plan_tile_unlimited_title: 'Unlimited',
  soho_user_plan_tile_unlimited_unit_data_description: 'data',
  soho_user_plan_tile_unlimited_unit_mins_description: 'mins',
  soho_user_plan_tile_unlimited_unit_sms_description: 'SMS',
  soho_user_requests_number_of_requested_users: 'Requests from %1$s users',
  soho_user_requests_title: 'User requests'
}
